import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import {
    makeSelectPrefetchProgressPercent,
    makeSelectPrefetchProgressLoading,
} from '@ts/core/selectors/app';

const Line = styled.div.attrs((props) => ({
    style: {
        width: `${props.percent}%`,
    },
}))`
    height: 100%;
    background: #00b357;
    will-change: width;
`;

const Wrapper = styled.div`
    height: 5px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    width: 100%;
    background: #fff;

    /* Mobile */
    @media only screen and (max-width: 767px) {
        height: 2px;
    }
`;

const style = { a: {}, b: { transition: 'width 0.3s cubic-bezier(1, 0, 0.8, 1)' } };

function ProgressBar() {
    const loading = useSelector(makeSelectPrefetchProgressLoading());
    const percent = useSelector(makeSelectPrefetchProgressPercent());

    return (
        <Wrapper style={{ opacity: loading ? 1 : 0 }}>
            <Line percent={percent} style={loading ? style.b : style.a} />
        </Wrapper>
    );
}

export default ProgressBar;
